import React from 'react';
const Contact = () => {
  return (
    <section id="contact">
      <div className="container">
        <h2 className="section-title">Informasi Lebih Lanjut</h2>
        <div className="contact">
          <h3>Hubungi Kami</h3>
          <p>Untuk informasi selanjutnya, silahkan kirimkan pesan ke WhatsApp kami:</p>
          <a 
            href="https://wa.me/6285930139333?text=Halo,%20saya%20[Nama%20Kamu].%20Saya%20ingin%20bergabung%20dengan%20WM%20MANAGEMENT%20karena%20saya%20tertarik%20dengan%20program%20ini.%20Saya%20siap%20mengikuti%20aturan%20dan%20kontribusi%20positif.%20Mohon%20info%20langkah%20selanjutnya.%20Terima%20kasih%20banyak." 
            className="whatsapp-button" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp"></i> DAFTAR SEKARANG
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
